/* ========================================
   FORGELINE — Homepage reveal controller
   One shared IntersectionObserver for every
   [data-reveal] element on the homepage.

   Progressive enhancement contract:
   - Elements are VISIBLE by default (CSS does not
     hide anything on its own).
   - Only after we confirm JS runs, motion is allowed,
     and IntersectionObserver exists do we opt elements
     into the hidden/animated state.
   - So if this script fails to load or run, the homepage
     simply renders fully visible with no animation.
   ======================================== */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  // Optional live speed override for previews: ?anim=<multiplier> (higher =
  // slower), clamped to a sane range. Lets the speed be tuned on the preview
  // without a redeploy. No-op in normal use.
  try {
    var animParam = new URLSearchParams(window.location.search).get('anim');
    if (animParam) {
      var mult = parseFloat(animParam);
      if (!isNaN(mult)) {
        mult = Math.min(3, Math.max(0.5, mult));
        document.documentElement.style.setProperty('--fg-speed', String(mult));
      }
    }
  } catch (e) {}

  ready(function () {
    var els = Array.prototype.slice.call(document.querySelectorAll('[data-reveal]'));
    if (!els.length) return;

    var reduceMotion =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // Leave everything visible if we can't (or shouldn't) animate.
    if (reduceMotion || !('IntersectionObserver' in window)) return;

    // 1) Hide instantly — suppress transitions for one frame so there is
    //    no fade-out flash before the reveal animation.
    els.forEach(function (el) {
      el.classList.add('fg-reveal--ready', 'fg-reveal--instant');
    });
    void document.documentElement.offsetWidth; // force reflow
    els.forEach(function (el) {
      el.classList.remove('fg-reveal--instant');
    });

    function reveal(el) {
      el.classList.add('is-visible');
    }

    // 2) Split into on-load group (hero) and scroll group.
    var onLoadEls = [];
    var scrollEls = [];
    els.forEach(function (el) {
      if (el.closest('.fg-reveal-onload')) onLoadEls.push(el);
      else scrollEls.push(el);
    });

    // Hero reveals as soon as it is painted (staggered via CSS delays).
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        onLoadEls.forEach(reveal);
      });
    });

    // 3) Everything else reveals once when it scrolls into view.
    var observer = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          reveal(entry.target);
          obs.unobserve(entry.target); // animate once, then stop watching
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
    );

    scrollEls.forEach(function (el) {
      observer.observe(el);
    });
  });
})();
